import BoxIcon from "../../../../components/ui/box-icon/box-icon";
import imgDevelopment from "../../../../assets/images/about-development.jpeg";
import Icon from "../../../../components/ui/icon/icon";

import "./about-development.scss";
import { Fade } from "react-awesome-reveal";

const AboutDevelopment = () => {
  return (
    <section className="about-development">
      <div className="about-development__info-section">
        <Fade direction="left" duration={900} triggerOnce>
          <div className="about-development__icon">
            <BoxIcon icon={"calendar"} size={"medium"} type={"secondary"} />
          </div>
          <h2 className="about-development__title">
            Sviluppo e Innovazione Continua
          </h2>
          <div className="about-development__text-container">
            <p className="about-development__text">
              La Rotoinfissioni srl percorre attualmente un notevole sviluppo,
              arricchendosi di esperienza ed attrezzature, con un parco macchine
              tecnologicamente avanzato e costantemente rinnovato.
            </p>
            <Fade
              cascade
              direction="up"
              duration={1000}
              damping={0.2}
              triggerOnce
            >
              <div className="about-development__checked-item">
                <div className="about-development__checked-icon">
                  <Icon name={"checked"} size={"0.75rem"} />
                </div>
                <span className="about-development__checked-text">
                  Parco macchine tecnologicamente avanzato
                </span>
              </div>
              <div className="about-development__checked-item">
                <div className="about-development__checked-icon">
                  <Icon name={"checked"} size={"0.75rem"} />
                </div>
                <span className="about-development__checked-text">
                  Costante rinnovamento delle attrezzature
                </span>
              </div>
              <div className="about-development__checked-item">
                <div className="about-development__checked-icon">
                  <Icon name={"checked"} size={"0.75rem"} />
                </div>
                <span className="about-development__checked-text">
                  Crescita continua dell'esperienza
                </span>
              </div>
            </Fade>
          </div>
        </Fade>
      </div>

      <div className="about-development__img-section">
        <Fade direction="right" duration={900} delay={200} triggerOnce>
          <img
            className="about-development__img"
            src={imgDevelopment}
            alt="Parco macchine e attrezzature Rotoinfissioni"
          />
        </Fade>
      </div>
    </section>
  );
};

export default AboutDevelopment;
